import Joi from 'joi';
import PropTypes from 'prop-types';
import Form from '../../common/form';

import * as models from '../../../utils/models';

class RTWCoverForm extends Form {
	state = {
		data: initialData,
		errors: {},
		loading: false,
		progress: 0,
	};

	static propTypes = {
		onProceed: PropTypes.func,
	};

	schema = {
		scopeOfWork: Joi.string().min(5).required().label('Scope Of Work'),
		visualExamination: Joi.string()
			.min(5)
			.required()
			.label('Visual Examination Procedure'),
		radiographProcedure: Joi.string()
			.min(3)
			.required()
			.label('Radiographic Examination Procedure'),
		lptProcedure: Joi.string()
			.min(3)
			.required()
			.label('Liquid Penetrant Testing Procedure'),
		drawingNo: Joi.string().required().label('Drawing / P&ID Number'),
		circuteNo: Joi.string().required().label('Circute Number'),
		ndtQualification: Joi.string()
			.min(3)
			.required()
			.label('Qualification of NDT Personnel'),
		nonDestructiveTesting: Joi.string()
			.min(3)
			.required()
			.label('Non Destructive Testing'),

		processPiping: Joi.string()
			.min(3)
			.required()
			.label('Process Piping Design'),
		upstreamProcessPiping: Joi.string()
			.min(3)
			.required()
			.label('Upstream Process Piping Welding and Inspection'),
	};

	doSubmit = (): void => {
		const props: any = this.props;
		props.onProceed(this.state.data);

		this.setState({ data: initialData });
	};

	render() {
		return (
			<form autoComplete="off" onSubmit={this.handleSubmit}>
				<div className="row">
					<div className="col">
						{this.renderInput({
							type: 'text',
							name: 'scopeOfWork',
							label: 'Scope of work',
							placeholder: 'Enter Scope of Work',
						})}
					</div>

					<div className="col">
						{this.renderInput({
							type: 'text',
							name: 'visualExamination',
							label: 'Visual Examination Procedure',
							placeholder: 'Enter Visual Examination Procedure',
						})}
					</div>

					<div className="col">
						{this.renderInput({
							type: 'text',
							name: 'radiographProcedure',
							label: 'Radiographic Examination Procedure',
							placeholder: 'Enter Radiographic Examination Procedure',
						})}
					</div>

					<div className="col">
						{this.renderInput({
							type: 'text',
							name: 'lptProcedure',
							label: 'Liquid Penetrant Testing Procedure',
							placeholder: 'Enter Liquid Penetrant Testing Procedure',
						})}
					</div>

					<div className="col">
						{this.renderInput({
							type: 'text',
							name: 'drawingNo',
							label: 'Drawing / P&ID Number',
							placeholder: 'Enter Drawing / P&ID Number',
						})}
					</div>
				</div>

				<div className="divider my-4"></div>

				<div className="row">
					<div className="col">
						{this.renderInput({
							type: 'text',
							name: 'ndtQualification',
							label: 'Qualification of NDT Personnel',
							placeholder: 'e.g. ASNT SNT-TC-1A',
						})}
					</div>

					<div className="col">
						{this.renderInput({
							type: 'text',
							name: 'nonDestructiveTesting',
							label: 'Non Destructive Testing',
							placeholder: 'Enter Non Destructive Testing Value',
						})}
					</div>

					<div className="col">
						{this.renderInput({
							type: 'text',
							name: 'processPiping',
							label: 'Process Piping Design',
							placeholder: 'Enter Process Piping Design',
						})}
					</div>
				</div>

				<div className="divider my-4"></div>

				<div className="row">
					<div className="col">
						{this.renderInput({
							type: 'text',
							name: 'circuteNo',
							label: 'Circute Number',
							placeholder: 'Enter Circute Number',
						})}
					</div>

					<div className="col">
						{this.renderInput({
							type: 'text',
							name: 'upstreamProcessPiping',
							label: 'Upstream Process Piping Welding and Inspection',
							placeholder:
								'Enter Upstream Process Piping Welding and Inspection',
						})}
					</div>
				</div>

				<div className="d-flex justify-content-end">
					{this.renderButton('Proceed')}
				</div>
			</form>
		);
	}
}

export default RTWCoverForm;

const initialData: models.RTWCoverData = {
	scopeOfWork: '',
	visualExamination: '',
	radiographProcedure: '',
	lptProcedure: '',
	drawingNo: '',
	circuteNo: '',
	ndtQualification: '',
	nonDestructiveTesting: '',
	processPiping: '',
	upstreamProcessPiping: '',
};
